// @flow

import * as React from 'react';
import {
  Route,
  Redirect,
  HashRouter,
} from 'react-router-dom';

import { connect } from 'react-redux';
import styled from 'styled-components';
import ReactGA from 'react-ga';
import Content from './containers/content/Content';
import SignIn from './containers/signIn/SignIn';
import Register from './containers/register/Register';
import ResetPassword from './containers/resetPassword/ResetPassword';
import ForgotPassword from './containers/forgotPassword/ForgotPassword';
import Admin from './containers/admin/Admin';
import type { Project } from './types/auth';
import { GOOGLE_ANALYTICS_CODE } from './config';

import './css/fonts/fonts.css';
import './css/messages/messageStyles.css';

ReactGA.initialize(GOOGLE_ANALYTICS_CODE);
ReactGA.pageview(window.location.pathname + window.location.search);

const StyledApp = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  font-family: 'Open Sans', sans-serif;
`;

type Auth = {
  get: string => (string),
  login: string
};

type State = {
  auth: Auth
};

type Props = {
  isSignedIn: string,
  chosenProject: Project,
};

export class App extends React.Component<Props, State> {
  componentDidMount(){
    document.title = this.props.appName;
  }

  render() {
    const { isSignedIn, chosenProject }: Props = this.props;
    return (
      <HashRouter>
        <StyledApp className="App">
          <Route
            exact
            path="/"
            render={() => (<Redirect to="/main" />)}
          />
          <Route
            exact
            path="/main"
            render={() => (isSignedIn === 'true' && chosenProject !== null
              ? (<Content />)
              : (<Redirect to="/signin" />))
            }
          />
          <Route
            path="/signin"
            render={() => (isSignedIn === 'true' && chosenProject !== null
              ? (<Redirect to="/main" />)
              : (<SignIn />))
            }
          />
          <Route
            path="/admin"
            render={() => (isSignedIn !== 'true'
              ? (<Redirect to="/signin" />)
              : (<Admin />))
            }
          />
          <Route
            path="/register"
            render={() => (<Register />)}
          />
          <Route
            path="/reset_password"
            render={() => (<ResetPassword />)}
          />
          <Route
            path="/forgot_password"
            render={() => (<ForgotPassword type='forgot' />)}
          />
          <Route
            path="/resend_link"
            render={() => (<ForgotPassword type='lost' />)}
          />
          <Route
            path="/expiration_link"
            render={() => (<ForgotPassword type='expired' />)}
          />
        </StyledApp>
      </HashRouter>
    );
  }
};

const mapStateToProps = (state: State) => ({
  isSignedIn: state.auth.get('isSignedIn'),
  chosenProject: state.auth.get('chosenProject'),
  appName: state.domainProperties.get('appName')
});

export default connect(mapStateToProps, null)(App);



// WEBPACK FOOTER //
// ./src/App.jsx